import React from 'react';
import classNames from 'classnames';

import { useIntl } from '../../util/reactIntl';
import IconArrowHead from '../IconArrowHead/IconArrowHead';

import css from './BackButton.module.css';

/**
 * A round back-arrow button that navigates to the previous page in browser history
 * (e.g. back to search results with filters intact, since SearchPage keeps its state
 * in the URL).
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to component's own css.root
 * @param {string?} props.rootClassName overwrite component's own css.root
 * @param {Object} props.history history object from react-router, used to go back
 * @returns {JSX.Element} back button
 */
const BackButton = props => {
  const { className, rootClassName, history } = props;
  const intl = useIntl();
  const classes = classNames(rootClassName || css.root, className);

  return (
    <button
      type="button"
      className={classes}
      onClick={() => history.goBack()}
      aria-label={intl.formatMessage({ id: 'BackButton.ariaLabel' })}
    >
      <IconArrowHead direction="left" size="small" />
    </button>
  );
};

export default BackButton;
